<script setup>
import { useI18n } from 'vue-i18n';
import LaisField from 'dashboard/components-next/LaisField.vue';

defineProps({
  count: { type: Number, required: true },
  loading: { type: Boolean, default: false },
  options: { type: Array, default: () => [] },
  rows: { type: Array, default: () => [] },
});

const emit = defineEmits(['change-count', 'update-row']);
const { t } = useI18n();
</script>

<template>
  <LaisField :label="t('SALES.PENDING_CHARGE.PAYER_EDITOR.QUANTITY')" required>
    <select
      :value="count"
      :disabled="!options.length || loading"
      class="min-h-10 rounded-lais border border-lais-border bg-white px-3 text-sm disabled:bg-lais-bg-soft"
      @change="emit('change-count', $event.target.value)"
    >
      <option v-for="value in options.length" :key="value" :value="value">
        {{ value }}
      </option>
    </select>
  </LaisField>

  <div class="grid gap-4 lg:grid-cols-2">
    <div
      v-for="(row, index) in rows"
      :key="index"
      class="grid gap-4 rounded-lais border border-lais-border-soft p-4 sm:grid-cols-2"
    >
      <LaisField :label="t('SALES.PENDING_CHARGE.PAYER_EDITOR.PARTY')" required>
        <select
          :value="row.property_transaction_party_id"
          :disabled="!options.length || loading"
          class="min-h-10 rounded-lais border border-lais-border bg-white px-3 text-sm disabled:bg-lais-bg-soft"
          @change="
            emit('update-row', {
              index,
              field: 'property_transaction_party_id',
              value: $event.target.value,
            })
          "
        >
          <option value="">
            {{ t('SALES.PENDING_CHARGE.PAYER_EDITOR.SELECT') }}
          </option>
          <option v-for="option in options" :key="option.id" :value="option.id">
            {{ option.name }}
          </option>
        </select>
      </LaisField>
      <LaisField
        :label="t('SALES.PENDING_CHARGE.PAYER_EDITOR.AMOUNT')"
        required
      >
        <input
          :value="row.valor_pagamento"
          inputmode="decimal"
          :disabled="!options.length || loading"
          class="min-h-10 rounded-lais border border-lais-border px-3 text-sm disabled:bg-lais-bg-soft"
          @input="
            emit('update-row', {
              index,
              field: 'valor_pagamento',
              value: $event.target.value,
            })
          "
        />
      </LaisField>
    </div>
  </div>
</template>
